import React, { useEffect, useState } from 'react';
import { orderBy } from 'lodash';

const GridMissions = ({
  rows,
  onOpen,
}) => (
    <div className="assignments-grid-container position-relative">
      <div className="row assignments-grid -mt-n3">
      {orderBy(rows, 'slot').map((a, i) => {
        const isOpened = a.status != 'pending';
        const isCompleted = isOpened && a.status != 'opened';
        const isAnswering = a.status === 'answering' || a.status === 'started';
        console.log({ status: a.status, a });
        return (
          <div
            key={i}
            className="assignments-grid-item col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3 mt-3"
            style={{ position: 'relative' }}
          >
            <img className="assignments-grid-bs position-absolute" src="/assets/img/bookshelf.png"/>
            <div className="assignments-grid-item-box">
              <div className={`assignments-grid-item-detail p-3 ${isOpened ? 'opened' : ''}`} style={{ position: 'relative' }}>
                <div className="mission-slot-circle">
                  {String(a.slot).padStart(2, '0')}
                </div>
                <a className="link" onClick={() => { onOpen(a); }}>
                  { isAnswering ? '作答中' : isCompleted ? '重溫文章' : isOpened ? '待作答' : '打開我' }
                </a>
              </div>
            </div>
          </div>
        );
      })}
      </div>
    </div>
);

export default GridMissions;
